<template>
   <div class="body" v-if="is_loading">
        <!-- 네비게이션 -->
        <Head :time="current_time" :total_question="total_question" :current_question="current_question" @next="next" :total_part="total_part" :current_part="part"></Head>

        <div class="wrap body-con">
            <h2>아래 사진을 영어로 묘사하세요.<br><span>(상황, 인물, 장소 중심으로)</span></h2>
            <h3></h3>
            <div class="mb-40">
                <!-- <img src="../../assets/images/test.png" alt="" class="w-100per"> -->
                <img :src="modules.part[this.part][this.current_question].img_url" alt="" class="w-100per">
            </div>
            <div>
                <p class="txt-gray-light">Word Count {{word_count}}</p>
                <textarea name="" id="" rows="5" class="mt-10" @keyup="inputWord"></textarea>
            </div>
        </div>

        <div class="wrap">
            <div class="btn-fixed" v-if="is_next"><button class="btn-full"  @click="next()">NEXT</button></div>
            <div class="btn-fixed"  v-if="!is_next"><button class="btn-full on" >NEXT</button></div>
        </div>

        <!-- 푸터 -->
        <Footer></Footer>
    </div>
</template>
<script>
import Footer from '@/components/footer.vue';
import Head from '@/components/inc_head.vue';

export default {
    name: 'part04',
    components: {
        Footer,
        Head
    },
    data: () => ({
        current_time : {time:0},
        total_question:0,
        current_question:0,
        is_loading:false,
        modules:{},
        part:4,
        answer:"",
        type:"",
        total_part:{part:0},
        word_count:0,
        is_next:false
    }),
    mounted() {
       this.type = this.$route.params.type;
       this.getQuestion();
    },
    methods: {
        getQuestion(){
            var params = {
                type:this.type,
                part:this.part
            }
            this.axios.get(this.axios.root + "/rest/module_info/getQuestions",{params:params}).then((res)=>{
                console.log(JSON.stringify(res.data.data));
                if(res.data.err == 0){
                    this.total_part = {part:parseInt(res.data.data.total_part)};
                    this.total_question = res.data.data.total_question;
                    this.modules = res.data.data.modules;
                    this.current_question = parseInt(res.data.data.submit_answer);
                    this.current_time.time = this.modules.part[this.part][this.current_question].second * 1000;
                    this.is_loading = true;
                }else if(res.data.err == 5000){
                    alert(res.data.err_msg);
                    sessionStorage.clear();
                    location.href="/intro";
                }else if(res.data.err == 6001){
                    alert(res.data.err_msg);
                    this.$router.push('/part05/'+this.type);
                }else{
                    alert(res.data.err_msg);
                    return false;
                }
            })
        },
        next(){
            this.answer = this.answer.trim();
            var params = {
                part :this.part,
                number : (this.current_question+1),
                type:this.type,
                student_idx:sessionStorage.getItem("student_idx"),
                answer:this.answer
            }
            console.log(params);
            this.axios.post(this.axios.root + "/rest/access/answerSubmit",params).then((res) => {
                if(res.data.err == 0){
                    this.answer = "";
                    this.memetos = [];
                    this.select_item = [];
                    this.word_count = 0;
                    if((this.current_question + 1) == this.modules.part[this.part].length){
                        this.$router.push('/part05/'+this.type);
                    }else{
                        this.current_question++;
                        this.current_time = {time:this.modules.part[this.part][this.current_question].second * 1000};
                    }
                }else{
                    alert(res.data.err_msg);
                    return false;
                }
            });
        },
        inputWord(e){
            this.answer = e.target.value;
            // console.log(this.answer);
            var answerSplit = this.answer.split(" ");
            // console.log(answerSplit.length - 1);
            // this.word_count = this.answer.replace(/ /gi, "").length;
            this.word_count = answerSplit.length - 1;
            this.is_next = true;
        }
    }
}
</script>